import SoundManager from "../../../../../../../shared/lib/html5-software-library/src/ranj/audio/SoundManager";
import Button from "../../../../../../../shared/lib/html5-software-library/src/ranj/components/buttons/Button";
import ContentTypes from "../../../../../../../shared/lib/html5-software-library/src/ranj/eng/content/ContentTypes";
import LanguagePack from "../../../../../../../shared/lib/html5-software-library/src/ranj/language/LanguagePack";
import Anchor from "../../../../../../../shared/lib/html5-software-library/src/ranj/layout/Anchor";
import { isNull } from "../../../../../../../shared/lib/html5-software-library/src/ranj/util/TypeUtil";
import AssetLibrary from "../../../../../../../shared/src/ranj/app/assetloading/AssetLibrary";
import AssetLoadService from "../../../../../../../shared/src/ranj/app/assetloading/AssetLoadService";
import GameEvent from "../../../../../../../shared/src/ranj/app/core/GameEvent";
import MediatorManager from "../../../../../../../shared/src/ranj/app/core/MediatorManager";
import SoundType from "../../../../../../../shared/src/ranj/app/sound/SoundType";
import SkinKeys from "../../../../../../../shared/src/ranj/app/ui/SkinKeys";
import GameConfig from "../../../core/model/GameConfig";
import AbstractCollaborationScreenMediator from "../../../core/view/AbstractCollaborationScreenMediator";
import NGTAssetLocator from "../../base/NGTAssetLocator";
import DebugEvent from "../../debug/DebugEvent";
import ScenarioLibrary from "../../scenario/ScenarioLibrary";
import NGTDialogPlayerEvent from "../NGTDialogPlayerEvent";
import BalloonView from "./BalloonView";
import DialogOptionHelper from "./DialogOptionHelper";
import DialogSceneView from "./DialogSceneView";
import InfoBalloonView from "./InfoBalloonView";
import NPCBalloonView from "./NPCBalloonView";

export default class DialogScreenMediator extends AbstractCollaborationScreenMediator {
    /**
     * 
     * @param {*} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LanguagePack} languagePack 
     * @param {SoundManager} soundManager 
     * @param {AssetLibrary} assetLibrary 
     * @param {NGTAssetLocator} assetLocator 
     * @param {AssetLoadService} assetLoadService 
     * @param {ScenarioLibrary} scenarioLibrary 
     * @param {MediatorManager} mediatorManager 
     * @param {GameConfig} config
     */
    constructor(target, dispatcher, languagePack, layoutManager, soundManager, assetLibrary, assetLocator, assetLoadService, scenarioLibrary,
        mediatorManager, config, gameAssets, gameModel, dialogSceneAssets) {

        super(target, dispatcher, languagePack, layoutManager, soundManager, gameAssets, gameModel);

        this._onDialogContentBound = this._onDialogContent.bind(this);
        this._onDialogOptionsChangedBound = this._onDialogOptionsChanged.bind(this);
        this._onDialogOptionChosenBound = this._onDialogOptionChosen.bind(this);
        this._onDialogEndBound = this._onDialogEnd.bind(this);

        this._assetLibrary = assetLibrary;
        this._assetLocator = assetLocator;
        this._assetLoadService = assetLoadService;
        this._scenarioLibrary = scenarioLibrary;
        this._mediatorManager = mediatorManager;
        this._config = config;
        this._dialogSceneAssets = dialogSceneAssets;
    }

    destroy() {
        this._removeDialogPlayerListeners();

        this._dialogPlayerOptionsMediator.destroy();

        this._dispatcher.removeEventListener(GameEvent.PAUSE_GAME, this._handlePauseGameBound);
        this._dispatcher.removeEventListener(GameEvent.RESUME_GAME, this._handleResumeGameBound);
        this._dispatcher.removeEventListener(DebugEvent.SKIP_CONTENT, this._skipContentFunction);

        window.document.removeEventListener("keyup", this._handleKeyUp);
        super.destroy();
    }

    initialize() {
        //this._target.dialogPlayer set in PlayDialogCommand
        this.setDialogPlayer(this._target.dialogPlayer);
        this._target.dialogPanel.dialogPlayer = this._dialogPlayer;

        // Sub-mediators
        this._dialogPlayerOptionsMediator = this._mediatorManager.createMediator(this._target.dialogPanel, SkinKeys.DIALOG_OPTIONS_SKIN);

        this._sceneView = new DialogSceneView(this._target.imageContainer);

        this._balloons = {};
        Object.keys(BalloonTypes).forEach(balloonType => {
            const balloonSkin = this._target[balloonType + "Balloon"];
            const balloonView = this._createBalloonView(BalloonTypes[balloonType], balloonSkin);
            balloonView.setText("");
            balloonView.visible = false;
            if (!this._balloonDefault) {
                this._balloonDefault = balloonView;
            }
            this._balloons[balloonType] = balloonView;
        });
        this._currentTextBalloon = this._balloonDefault;

        // continue button handling
        this.continueButton = new Button(this._target.continueButton);
        this.continueButton.setLabel(this._languagePack.getText("dialog.continue.button"));
        this.continueButton.addEventListener('click', this._handleContinueButtonClicked.bind(this));
        this.continueButton.setVisible(false);

        this._showText("", false);

        // Skipping content
        this._skipContentFunction = this._onSkipContent.bind(this);
        this._dispatcher.addEventListener(DebugEvent.SKIP_CONTENT, this._skipContentFunction);

        //Pause/resume
        this._handlePauseGameBound = this._handlePauseGame.bind(this);
        this._handleResumeGameBound = this._handleResumeGame.bind(this);
        this._dispatcher.addEventListener(GameEvent.PAUSE_GAME, this._handlePauseGameBound);
        this._dispatcher.addEventListener(GameEvent.RESUME_GAME, this._handleResumeGameBound);

        this.addInfoPanel(false);
        //Let's not anchor the image and balloons at top, because that makes the bottom part of the screen look weird.
        // this.anchorObject(this._target.imageContainer, Anchor.T);
        // Object.values(this._balloons).forEach(balloon => {
        //     this.anchorObject(balloon.target, Anchor.T);   
        // });      
        this.anchorObject(this._target.dialogPanel, Anchor.B);
        this.anchorObject(this.continueButton.skin, Anchor.B);

        //Reapply state?        
        //this._target.state set in PlayDialogCommand
        if (this._target.dialogMemento) {
            this._showImageAsScene(this._target.dialogMemento.imageId);
        }

        this._createFadeOverlay();
        this._fadeIn();

        this.checkSavegameRestoredFeedback();

        if (ranj.DEBUG) {
            this._handleKeyUp = this._handleKeyUp.bind(this);
            this._history = [];
            window.document.addEventListener("keyup", this._handleKeyUp);
        }
    }

    // ------------------------------------------
    // 			Dialog listeners
    // ------------------------------------------

    _addDialogPlayerListeners() {
        if (isNull(this._dialogPlayer)) return;

        this._dialogPlayer.eventDispatcher.addEventListener(NGTDialogPlayerEvent.DIALOG_CONTENT, this._onDialogContentBound);
        this._dialogPlayer.eventDispatcher.addEventListener(NGTDialogPlayerEvent.DIALOG_OPTIONS_CHANGED, this._onDialogOptionsChangedBound);
        this._dialogPlayer.eventDispatcher.addEventListener(NGTDialogPlayerEvent.DIALOG_OPTION_CHOSEN, this._onDialogOptionChosenBound);
        this._dialogPlayer.eventDispatcher.addEventListener(NGTDialogPlayerEvent.DIALOG_END, this._onDialogEndBound);
    }

    _removeDialogPlayerListeners() {
        if (isNull(this._dialogPlayer)) return;

        this._dialogPlayer.eventDispatcher.removeEventListener(NGTDialogPlayerEvent.DIALOG_CONTENT, this._onDialogContentBound);
        this._dialogPlayer.eventDispatcher.removeEventListener(NGTDialogPlayerEvent.DIALOG_OPTIONS_CHANGED, this._onDialogOptionsChangedBound);
        this._dialogPlayer.eventDispatcher.removeEventListener(NGTDialogPlayerEvent.DIALOG_OPTION_CHOSEN, this._onDialogOptionChosenBound);
        this._dialogPlayer.eventDispatcher.removeEventListener(NGTDialogPlayerEvent.DIALOG_END, this._onDialogEndBound);
    }

    // ------------------------------------------
    // 			Dialog handlers
    // ------------------------------------------

    _onDialogContent({ params }) {
        const dialogContentPackage = params.data.data;
        if (!dialogContentPackage) {
            return;
        }

        const content = dialogContentPackage.content;
        switch (content.getType()) {
            case ContentTypes.TYPE_TEXT:
                this._handleTextContent(content);
                this._dialogPlayer.contentCompleted(content);
                break;

            case ContentTypes.TYPE_IMAGE:
                this._handleImageContent(content);
                this._dialogPlayer.contentCompleted(content);
                break;

            default:
                this._dialogPlayer.contentCompleted(content);
                break;
        }
    }

    _onDialogOptionsChanged(event) {
        this._handleDialogOptionsChanged();
    }

    _onDialogOptionChosen({ params }) {
        this._currentTextBalloon.visible = false;
    }

    _onDialogEnd(event) {
        this.setDialogPlayer(null);
    }

    // ------------------------------------------
    // 			Content delegates
    // ------------------------------------------

    getDialogPlayer() {
        return this._dialogPlayer;
    }

    setDialogPlayer(value) {
        if (this._dialogPlayer !== null) {
            this._removeDialogPlayerListeners();
        }

        this._dialogPlayer = value;

        if (this._dialogPlayer !== null) {
            this._addDialogPlayerListeners();
        }
    }

    // ------------------------------------------
    // 			Debug methods
    // ------------------------------------------

    _handleKeyUp(e) {
        const code = e.which;
        const c = String.fromCharCode(code);
        if (c == "N") {
            this.getDialogPlayer().handleEndDialog();
        } else if (code == 37) {//left arrow (39 == right arrow)
            this._back();
        }
    }

    _back() {
        const dialogMemento = this.getDialogPlayer().back();
        if (dialogMemento) {
            this.continueButton.setVisible(false);
            this._dialogPlayerOptionsMediator._clearOptionButtons();
            this._dialogPlayerOptionsMediator._processDialogOptions();
            this._imageID = dialogMemento.imageId;
            this._showImageAsScene(dialogMemento.imageId);
            if (this._backFeedbackTimeout != null) {
                this.killDelayedCall(this._backFeedbackTimeout);
            }
            this._backFeedbackTimeout = this.callDelayed(() => {
                this._backFeedbackTimeout = null;
                this.showFeedback("[stepped back]");
            }, 500);
        }
    }

    // -----------------------------------------
    // Continue button
    // -----------------------------------------

    _handleContinueButtonClicked(e) {
        this.continueButton.setEnabled(false);
        this._soundManager.playSound(SoundType.SOUND_CLICK);
        this.getDialogPlayer().optionChosen(this.continueOption);
    }

    // ------------------------------------------
    // 	Dialog Content handlers
    // ------------------------------------------

    _handleTextContent(content) {
        //hide all balloons
        // and auto hide continue buttons
        Object.values(this._balloons).forEach(balloon => {
            balloon.visible = false;
        });
        this.continueButton.setVisible(false);

        const balloonType = content.getBalloonType();
        const sceneBalloon = this._sceneView.getBalloon();
        if (sceneBalloon) {
            const balloonClass = BalloonTypes[balloonType] ? BalloonTypes[balloonType] : BalloonView;
            this._currentTextBalloon = this._createBalloonView(balloonClass, sceneBalloon);
        } else {
            this._currentTextBalloon = this._balloons[balloonType] || this._balloonDefault;
        }

        this._currentTextBalloon.visible = true;

        this._showText(content.getText(), true);
    }

    _createBalloonView(type, skin) {
        return new type(skin);
    }

    _handleImageContent(content) {
        const imageID = content.getImage();
        // Only load & show when this is another image than the current one
        if (this._imageID === imageID) {
            return;
        }
        this._imageID = imageID;
        this._showImageAsScene(imageID);
    }

    _showImageAsScene(imageID) {
        this._sceneView.createAndShowScene(imageID, this._dialogSceneAssets);
    }

    // ------------------------------------------
    // 	 Dialog displaying
    // ------------------------------------------

    _showText(text, animate) {
        this._currentTextBalloon.setText(text, animate);
    }

    _onDialogEnd(event) {
        this._fadeOut(() => {
            this.getDialogPlayer().completeContent();
            this._onDialogEnd(event);
        });
    }

    _handleDialogOptionsChanged() {
        this.continueButton.setVisible(false);
        // Check for "continue" option
        const currentOptions = this.getDialogPlayer().getCurrentOptions();

        for (let i = 0; i < currentOptions.length; i++) {
            if (DialogOptionHelper.isContinueOption(currentOptions[i])) {
                setTimeout(() => {
                    this.continueButton.setEnabled(true);
                    this._animateElementIn(this.continueButton.target);
                }, 1000 / this._speedFactor);
                this.continueOption = currentOptions[i];
            }
        }
    }

    _animateElementIn(target, delay) {
        target.visible = true;
        target.alpha = 0;
        if (!target.scaleOrig) {
            target.scaleOrig = target.scaleX;
        }
        target.scaleX = target.scaleY = .1 * target.scaleOrig;
        createjs.Tween.get(target)
            .wait(delay / this._speedFactor)
            .to({ alpha: 1, scaleX: target.scaleOrig, scaleY: target.scaleOrig }, 200 / this._speedFactor, createjs.Ease.backOut);
    }

    // ------------------------------------------
    //			PAUSE / RESUME / SKIP
    // ------------------------------------------
    _onSkipContent(e) {
        if (this._config.getValue("settings.skippableContent")) {
            if (!isNull(this._currentAudioID)) {
                this._soundManager.stopStreamSound(this._currentAudioID);
                this._handleSoundComplete(this._currentAudioID);
            }
        }
    }

    _handlePauseGame(event) {
        this.setPaused(true);
    }

    _handleResumeGame(event) {
        this.setPaused(false);
    }

    setPaused(value) {
        console.log(`DialogPlayerMediator.setPaused: ${value}, video: ${!isNull(this.videoPlayer)} audio: ${!isNull(this._currentAudioID)}`);
        if (!isNull(this._currentAudioID)) {
            if (value)
                this._soundManager.pause();
            else
                this._soundManager.resume();
        }
    }
}

const BalloonTypes = {
    npc: NPCBalloonView,
    info: InfoBalloonView
}